import React from "react";

const LazyProfile = React.lazy(() => import("./myProfile"));

const MyProfile = (props: Record<string, any>) => (
  <React.Suspense fallback={null}>
    <LazyProfile {...props} />
  </React.Suspense>
);

export default MyProfile;
